import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbAccordionModule,
  NgbCollapseModule,
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbPaginationModule,
  NgbPopoverModule,
  NgbTooltipModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { SubscriptionChangeComponent } from '../apollo-subscriptions/subscription-change/subscription-change.component';
import { CategoryAddComponent } from '../categories/category-add/category-add.component';
import { ClientAddComponent } from '../clients/client-add/client-add.component';
import { ReminderSendComponent } from '../clients/reminder/reminder-send.component';
import { DefaultEditTextComponent } from '../defaults/default-edit-text/default-edit-text.component';
import { DocumentCategoryAddComponent } from '../documents/document-categories/document-category-add/document-category-add.component';
import { DocumentCategoryComponent } from '../documents/document-categories/document-category/document-category.component';
import { DocumentClientSelectComponent } from '../documents/document-client-select/document-client-select.component';
import { DocumentItemInventoryQtyComponent } from '../documents/document-item-inventory-qty/document-item-inventory-qty.component';
import { DocumentItemSaveBtnComponent } from '../documents/document-item-save-btn/document-item-save-btn.component';
import { DocumentItemTaxComponent } from '../documents/document-item-taxes/document-item-tax/document-item-tax.component';
import { DocumentItemTaxesComponent } from '../documents/document-item-taxes/document-item-taxes.component';
import { DocumentItemTrackInventoryComponent } from '../documents/document-item-track-inventory/document-item-track-inventory.component';
import { DocumentPaymentNewComponent } from '../documents/document-payments-new/document-payment-new/document-payment-new.component';
import { DocumentReverseTaxTableComponent } from '../documents/document-reverse-tax-table/document-reverse-tax-table.component';
import { DocumentStatusComponent } from '../documents/document-status-badge/document-status.component';
import { DocumentTaxesTableComponent } from '../documents/document-taxes-table/document-taxes-table.component';
import { DocumentTotalsTableComponent } from '../documents/document-totals-table/document-totals-table.component';
import { DocumentTypeIndicatorComponent } from '../documents/document-type-indicator/document-type-indicator.component';
import { EmailDocumentComponent } from '../documents/email-document/email-document.component';
import { ListTotalConvertedComponent } from '../documents/list-total-converted/list-total-converted.component';
import { AttachmentComponent } from '../documents/outgoing/document-view/attachments/attachment/attachment.component';
import { AttachmentsComponent } from '../documents/outgoing/document-view/attachments/attachments.component';
import { DocumentIssuerComponent } from '../documents/outgoing/document-view/document-issuer/document-issuer.component';
import { DocumentViewClientComponent } from '../documents/outgoing/document-view/document-view-client/document-view-client.component';
import { DocumentViewDatesComponent } from '../documents/outgoing/document-view/document-view-dates/document-view-dates.component';
import { DocumentViewDocumentComponent } from '../documents/outgoing/document-view/document-view-document/document-view-document.component';
import { DocumentViewFiscalizationComponent } from '../documents/outgoing/document-view/document-view-fiscalization/document-view-fiscalization.component';
import { DocumentViewItemComponent } from '../documents/outgoing/document-view/document-view-item/document-view-item.component';
import { DocumentViewItemsComponent } from '../documents/outgoing/document-view/document-view-items/document-view-items.component';
import { DocumentViewLogoComponent } from '../documents/outgoing/document-view/document-view-logo/document-view-logo.component';
import { DocumentViewPaymentsComponent } from '../documents/outgoing/document-view/document-view-payments/document-view-payments.component';
import { DocumentViewReferencedComponent } from '../documents/outgoing/document-view/document-view-referenced/document-view-referenced.component';
import { DocumentViewStatusComponent } from '../documents/outgoing/document-view/document-view-status/document-view-status.component';
import { DocumentViewWarehouseTransferComponent } from '../documents/outgoing/document-view/document-view-warehouse-transfer/document-view-warehouse-transfer.component';
import { PaymentQrComponent } from '../documents/outgoing/document-view/payment-qr/payment-qr.component';
import { FeatureModalModule } from '../feature-modal/feature-modal.module';
import { QrCodeComponent } from '../fina/qr-code/qr-code.component';
import { GuestbookAddComponent } from '../guestbook/guestbook-add/guestbook-add.component';
import { ReportViewComponent } from '../guestbook/report-view/report-view.component';
import { HeadComponent } from '../head/head.component';
import { HelpModalModule } from '../help-modal/help-modal.module';
import { ItemAddComponent } from '../items/item-add/item-add.component';
import { PaginationPageSelectComponent } from '../pagination-page-select/pagination-page-select.component';
import { PaymentAddComponent } from '../payments/payment-add/payment-add.component';
import { PriceListAddComponent } from '../price-lists/price-list-add/price-list-add.component';
import { SetPriceComponent } from '../price-lists/price-list-view/set-price/set-price.component';
import { RecurrenceAddComponent } from '../recurrences/recurrence-add/recurrence-add.component';
import { BusinessPremiseAddComponent } from '../settings/furs/business-premise-add/business-premise-add.component';
import { DeviceAddComponent } from '../settings/furs/device-add/device-add.component';
import { FileDropNewComponent } from '../shared/components/file-drop-new/file-drop-new.component';
import { InputSwitchListComponent } from '../shared/components/input-switch-list/input-switch-list.component';
import { ListBulkActionsComponent } from '../shared/components/list-bulk-actions/list-bulk-actions.component';
import { ListBulkCheckboxComponent } from '../shared/components/list-bulk-checkbox/list-bulk-checkbox.component';
import { ListFiltersBtnComponent } from '../shared/components/list-filters-btn/list-filters-btn.component';
import { ListFiltersComponent } from '../shared/components/list-filters/list-filters.component';
import { ListItemCheckboxComponent } from '../shared/components/list-item-checkbox/list-item-checkbox.component';
import { ContentLoaderComponent } from '../shared/components/table-loader/content-loader.component';
import { AutoExpandDirective } from '../shared/directives/auto-expand.directive';
import { SmartcodePreviewDirective } from '../shared/directives/smartcode-preview.directive';
import { PricingFaqComponent } from '../subscriptions/pricing-faq/pricing-faq.component';
import { ButtonWithLoaderComponent } from './components/button-with-loader/button-with-loader.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { InputFlagsComponent } from './components/input-flags/input-flags.component';
import { OrganizationEditComponent } from './components/organization-edit/organization-edit.component';
import { ProfitAndLossComponent } from './components/profit-and-loss/profit-and-loss.component';
import { DataFormComponent } from './data-form/data-form.component';
import { BaseListHeaderDirective } from './directives/base-list-header.directive';
import { DropzoneDirective } from './directives/dropzone.directive';
import { IframeHeightDirective } from './directives/iframe-height.directive';
import { PrimaryColorDirective } from './directives/primary-color.directive';
import { NotZeroValidatorDirective } from './directives/valid-payment.directive';
import { NotEmptyValidatorDirective } from './directives/validate-empty.directive';
import { IfWlDirective } from './if-wl.directive';
import { MomentDateFormatter } from './ngb-datepicker-custom-formatter';
import { NumberPrefixPipe } from './pipes/number-prefix.pipe';
import { PepAttachmentEllipsis } from './pipes/pep-attachment-ellipsis.pipe';
import { PepAttachmentUrl } from './pipes/pep-attachment-url.pipe';
import { PepCurrencyPipe } from './pipes/pep-currency.pipe';
import { PepDatePipe } from './pipes/pep-date.pipe';
import { PepEllipsisPipe } from './pipes/pep-ellipsis.pipe';
import { PepKeysPipe } from './pipes/pep-keys.pipe';
import { PepNumberPipe } from './pipes/pep-number.pipe';
import { PepUcfirstPipe } from './pipes/pep-ucfirst.pipe';
// import { LayoutModule } from '@angular/cdk/layout';
import { TranslateModule } from '@ngx-translate/core';
import { SubscriptionExpirationBannerComponent } from '../apollo-subscriptions/subscription-expiration-banner/subscription-expiration-banner.component';
import { TableEmptyStateComponent } from '../shared/components/table-empty-state/table-empty-state.component';
import { TaxAddComponent } from '../taxes/tax-add/tax-add.component';
import { TranslatableInputComponent } from './components/translatable-input/translatable-input.component';
import { TranslatableTextareaComponent } from './components/translatable-textarea/translatable-textarea.component';
import { WarehouseSelectComponent } from './components/warehouse-select/warehouse-select.component';
import { UniqueDocumentNumberValidatorDirective } from './directives/unique-document-number.directive';
import { UniqueEmailValidatorDirective } from './directives/unique-email.directive';
import { ValidEmailValidatorDirective } from './directives/valid-email.directive';
import { ValidNumberValidatorDirective } from './directives/valid-number.directive';

/**
 * Do declare components, directives, and pipes in a shared module when those
 * items will be re-used and referenced by the components declared in other
 * feature modules.
 * Avoid providing services in share module
 * https://angular.io/guide/styleguide#shared-feature-module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgbAccordionModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbCollapseModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgbTypeaheadModule,
    NgbPaginationModule,
    NgSelectModule,
    NgbModalModule,
    TranslateModule,
    ReactiveFormsModule,
    RouterModule,
    NgxQRCodeModule,
    // LayoutModule,
    FeatureModalModule,
    HelpModalModule,
    // StripeConnectModule,
  ],
  providers: [
    { provide: NgbDateParserFormatter, useClass: MomentDateFormatter },
  ],
  declarations: [
    IframeHeightDirective,
    CategoryAddComponent,
    ClientAddComponent,
    GuestbookAddComponent,
    ReportViewComponent,
    BusinessPremiseAddComponent,
    ButtonWithLoaderComponent,
    DefaultEditTextComponent,
    DocumentCategoryAddComponent,
    DocumentCategoryComponent,
    DocumentPaymentNewComponent,
    DocumentReverseTaxTableComponent,
    DocumentTaxesTableComponent,
    DocumentTotalsTableComponent,
    DocumentStatusComponent,
    DocumentViewDocumentComponent,
    DocumentIssuerComponent,
    DocumentViewLogoComponent,
    DocumentViewClientComponent,
    DocumentViewStatusComponent,
    DocumentViewDatesComponent,
    DocumentViewWarehouseTransferComponent,
    DocumentViewItemsComponent,
    DocumentViewItemComponent,
    PaymentQrComponent,
    AttachmentsComponent,
    AttachmentComponent,
    DocumentViewReferencedComponent,
    DocumentViewFiscalizationComponent,
    DocumentViewPaymentsComponent,
    DropzoneDirective,
    EmailDocumentComponent,
    HeadComponent,
    ItemAddComponent,
    PriceListAddComponent,
    SetPriceComponent,
    NotEmptyValidatorDirective,
    NotZeroValidatorDirective,
    PaymentAddComponent,
    PepCurrencyPipe,
    PepDatePipe,
    PepEllipsisPipe,
    PepKeysPipe,
    PepNumberPipe,
    PepUcfirstPipe,
    PepAttachmentEllipsis,
    PepAttachmentUrl,
    PricingFaqComponent,
    PrimaryColorDirective,
    BaseListHeaderDirective,
    RecurrenceAddComponent,
    SubscriptionChangeComponent,
    TaxAddComponent,
    UniqueDocumentNumberValidatorDirective,
    UniqueEmailValidatorDirective,
    ValidEmailValidatorDirective,
    ValidNumberValidatorDirective,
    DeviceAddComponent,
    OrganizationEditComponent,
    DocumentClientSelectComponent,
    FileDropNewComponent,
    ContentLoaderComponent,
    TableEmptyStateComponent,
    ListBulkActionsComponent,
    ListBulkCheckboxComponent,
    ListItemCheckboxComponent,
    SmartcodePreviewDirective,
    AutoExpandDirective,
    ReminderSendComponent,
    ListFiltersComponent,
    InputSwitchListComponent,
    ListFiltersBtnComponent,
    DocumentTypeIndicatorComponent,
    DocumentItemSaveBtnComponent,
    DocumentItemTrackInventoryComponent,
    DocumentItemTaxesComponent,
    DocumentItemTaxComponent,
    ConfirmModalComponent,
    PaginationPageSelectComponent,
    SubscriptionExpirationBannerComponent,
    NumberPrefixPipe,
    WarehouseSelectComponent,
    InputFlagsComponent,
    TranslatableTextareaComponent,
    TranslatableInputComponent,
    DocumentItemInventoryQtyComponent,
    ListTotalConvertedComponent,
    ProfitAndLossComponent,
    ButtonWithLoaderComponent,
    QrCodeComponent,
    DataFormComponent,
    IfWlDirective,
  ],
  exports: [
    CategoryAddComponent,
    ClientAddComponent,
    GuestbookAddComponent,
    ReportViewComponent,
    BusinessPremiseAddComponent,
    ButtonWithLoaderComponent,
    DeviceAddComponent,
    DefaultEditTextComponent,
    DocumentCategoryAddComponent,
    DocumentCategoryComponent,
    DocumentPaymentNewComponent,
    DocumentReverseTaxTableComponent,
    DocumentTaxesTableComponent,
    DocumentTotalsTableComponent,
    DocumentStatusComponent,
    DocumentViewDocumentComponent,
    DocumentIssuerComponent,
    DocumentViewLogoComponent,
    DocumentViewClientComponent,
    DocumentViewStatusComponent,
    DocumentViewDatesComponent,
    DocumentViewWarehouseTransferComponent,
    DocumentViewItemsComponent,
    DocumentViewItemComponent,
    PaymentQrComponent,
    AttachmentsComponent,
    AttachmentComponent,
    DocumentViewReferencedComponent,
    DocumentViewFiscalizationComponent,
    DocumentViewPaymentsComponent,
    DropzoneDirective,
    CommonModule,
    EmailDocumentComponent,
    FormsModule,
    NgSelectModule,
    HeadComponent,
    ItemAddComponent,
    PriceListAddComponent,
    SetPriceComponent,
    NgbAccordionModule,
    NgbDatepickerModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgbTypeaheadModule,
    NgbPaginationModule,
    NotEmptyValidatorDirective,
    NotZeroValidatorDirective,
    PaymentAddComponent,
    PepCurrencyPipe,
    PepDatePipe,
    PepEllipsisPipe,
    PepKeysPipe,
    PepNumberPipe,
    PepUcfirstPipe,
    PepAttachmentEllipsis,
    PepAttachmentUrl,
    PricingFaqComponent,
    PrimaryColorDirective,
    BaseListHeaderDirective,
    ReactiveFormsModule,
    RecurrenceAddComponent,
    SubscriptionChangeComponent,
    TaxAddComponent,
    TranslateModule,
    UniqueDocumentNumberValidatorDirective,
    UniqueEmailValidatorDirective,
    ValidEmailValidatorDirective,
    ValidNumberValidatorDirective,
    NgxQRCodeModule,
    DocumentClientSelectComponent,
    FileDropNewComponent,
    ContentLoaderComponent,
    TableEmptyStateComponent,
    ListBulkActionsComponent,
    ListBulkCheckboxComponent,
    ListItemCheckboxComponent,
    SmartcodePreviewDirective,
    AutoExpandDirective,
    ReminderSendComponent,
    ListFiltersComponent,
    ListFiltersBtnComponent,
    InputSwitchListComponent,
    DocumentTypeIndicatorComponent,
    DocumentItemSaveBtnComponent,
    DocumentItemTrackInventoryComponent,
    DocumentItemTaxesComponent,
    DocumentItemTaxComponent,
    ConfirmModalComponent,
    PaginationPageSelectComponent,
    SubscriptionExpirationBannerComponent,
    NumberPrefixPipe,
    WarehouseSelectComponent,
    TranslatableTextareaComponent,
    TranslatableInputComponent,
    InputFlagsComponent,
    DocumentItemInventoryQtyComponent,
    ListTotalConvertedComponent,
    ProfitAndLossComponent,
    QrCodeComponent,
    DataFormComponent,
    IfWlDirective,
  ],
})
export class SharedModule {}
